<template>
  <div class="formDetailReportComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="col-10">
      <div class="ContainerRecordatorio">
        <div class="ContainerRecorda">
          <v-icon color="#f88623" x-large>mdi-alert-circle</v-icon>
          <p>
            <span>
              Esta pantalla permite realizar la consulta de las monetizaciones de estrellas realizadas en un periodo de 1 año
            </span>
          </p>
        </div>
        <v-form ref="formulario" lazy-validation class="mt-5 col-8">
          <div class="formReport">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              color="secondary"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedStartDate"
                  label="*Fecha Inicio Monetización"
                  color="secondary"
                  :rules="startDateRules"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localStartDate"
                color="primary"
                @change="handleStartDateChange"
              ></v-date-picker>
            </v-menu>
  
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              color="secondary"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedEndDate"
                  label="*Fecha Fin Monetización"
                  color="secondary"
                  :rules="endDateRules"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localEndDate"
                color="primary"
                @change="handleEndDateChange"
                ></v-date-picker>
            </v-menu>
          </div>
        </v-form>
      </div>
    </div>

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          bottom
          right
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="submitForm"
          ><v-icon dark>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>Descargar</span>
    </v-tooltip>
  </div>
</template>

<script>
import {
  REPORTS_M,
  ACTION_POST_HISTORIC_MONETIZATION
} from "@/views/reports/store/types/types.js";
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  name: "detailReportComponent",
  props: {
    report: {
      required: true,
    },
  },
  data() {
    return {
      formData: {
        startDate: null,
        endDate: null,
      },
      menu1: false, // Para el date picker de fecha inicio
      menu2: false, // Para el date picker de fecha fin
      localStartDate: null,
      localEndDate: null,
      formattedStartDate: '',
      formattedEndDate: '',
      loading: false,
      showErrorMessages: false,
      dialog: false,
      startDateRules: [
        v => !!v || 'Fecha Inicio Monetización es requerido',
      ],
      endDateRules: [
        v => !!v || 'Fecha Fin Monetización es requerido',
      ],
    };
  },
  methods: {
    handleStartDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      
      this.localStartDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.startDate = date;
      this.formattedStartDate = date;
      this.validateStartDate(modifiedDate);
      this.menu1 = false;
    },

    validateStartDate(modifiedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      
      if (selectedDate > today) {
        Swal.fire({
        icon: "error",
        title: "Fecha no válida",
        text: "La fecha inicio monetización no puede ser superior al día actual.",
        });
        this.localStartDate = null;
        this.formattedStartDate = "";
        this.formData.startDate = null;
        return;
      }

      if(this.formData.endDate != null){
        if (this.formData.startDate > this.formData.endDate) {
          Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "La fecha inicio monetización no puede ser superior a la fecha fin monetización.",
          });
          this.localStartDate = null;
          this.formattedStartDate = "";
          this.formData.startDate = null;
          return;
        }
      }
    },

    handleEndDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      this.localEndDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.endDate = date;
      this.formattedEndDate = date;
      this.validateEndDate(this.localEndDate, modifiedDate);
      this.menu2 = false;
    },

    validateEndDate(localEndDate, modifiedDate) {
      if (localEndDate < this.localStartDate) {
        Swal.fire({
        icon: "error",
        title: "Fecha no válida",
        text: "La fecha fin monetización no puede ser inferior a la fecha inicio monetización.",
        });
        this.localEndDate = null;
        this.formattedEndDate = "";
        this.formData.endDate = null;
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      
      if (selectedDate > today) {
        Swal.fire({
        icon: "error",
        title: "Fecha no válida",
        text: "La fecha fin monetización no puede ser superior al día actual.",
        });
        this.localEndDate = null;
        this.formattedEndDate = "";
        this.formData.endDate = null;
        return;
      }
    },

    async submitForm() {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join("<br>");
          Swal.fire({
            icon: "error",
            title: "Errores de validación",
            html:
              '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
            confirmButtonColor: "#6E17A5",
          });
          return;
        }

        const body = {
          startDate: this.formData.startDate,
          endDate: this.formData.endDate
        }
        
        const historic = await this.postHistoricMonetization(body);
        if (historic.data.payload.fileName != null) {
          this.downloadExcelFile(historic.data.payload)
        } else {
          Swal.fire({
          icon: "info",
          title: "No hay información para descargar",
          text: historic.data.payload.message,
          });
          return;
          }
      } catch (error) {
        console.error("Fallo al descargar archivo");
      }
    },


    downloadExcelFile(responsePayload) {

      const base64 = responsePayload.content;
      const fileName = responsePayload.fileName;
      const contentType = responsePayload.typeContent;
    
      // Decodificar base64 a binario
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
    
      // Crear Blob
      const blob = new Blob([byteArray], { type: contentType });
    
      // Crear URL y descargar
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
      // Limpiar memoria
      URL.revokeObjectURL(link.href);
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.startDate) {
        errors.startDate = 'Fecha Inicio Monetización';
      }

      if (!this.formData.endDate) {
        errors.endDate = 'Fecha Fin Monetización';
      }
      return errors;
    },

    ...mapActions({
      postHistoricMonetization: `${REPORTS_M}${ACTION_POST_HISTORIC_MONETIZATION}`,
    }),
  },
};
</script>

<style lang="css" scoped>
.formDetailReportComponent {
  display: flex;
  justify-content: center;
}

.ContainerRecorda {
  background-color: #ff770048;
  width: 92%;
  height: 75px;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
  padding-left: 15px;
}

.ContainerRecordatorio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin: 20px 0px;
}

.ContainerRecordatorio p {
  margin-bottom: 0 !important;
}

p span {
  color: #6e17a5;
  font-weight: bold;
  font-size: 15px;
}

.formReport {
  display: flex;
  gap: 60px;
  flex-direction: row;
  justify-content: center;
}

/*Resposive*/

@media screen and (max-width: 768px) {
  .formReport {
    display: flex;
    gap: 40px;
    flex-direction: column;
    justify-content: center;
  }

  p span {
    font-size: 12px;
  }
}

@media screen and (max-width: 425px) {
  .formReport {
    display: flex;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
